// extracted by mini-css-extract-plugin
export default {"Wrapper":"PasswordRecoveryComplete_Wrapper__TJp9T","Logo":"PasswordRecoveryComplete_Logo__Jwfvp"};